export const importHtmx = (scope) => {
  const script = document.createElement("script");
  script.src = "https://unpkg.com/htmx.org@1.7.0/dist/htmx.js"; // location of your draggable js file that is responsible for that image loading and dragging functionality
  scope.container.appendChild(script);
};
